import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/rhea/theme.css'

export default PrimeVue;